module.exports = __webpack_public_path__ + "assets/img/huadong.3f07366c.png";